module.exports = __webpack_public_path__ + "img/masterclass_couple.88e8245f.jpg";